import React from "react";
import axios from "axios";
import styles from "./searchAutoComplete/SearchAutoComplete.module.scss"
import {useHistory} from "react-router-dom";
import http from "../../../../../services/api/utilities/http";

const SearchAutoComplete = props => {
    const history = useHistory()

    const handleSearch = keyboard => {
        const token = localStorage.getItem('token')
        const queryParams = new URLSearchParams(window.location.search);
        if(keyboard.length >= 3 || keyboard.length === 0) {
            if (keyboard.length >= 3) {
                queryParams.set('search', keyboard);
            } else {
                queryParams.delete("search")
            }
            http.get('authentication/user_management/?page=1&' + queryParams)
                .then(res => {
                    props.setUser(res.data.data.results)
                    delete res.data.data.results
                    props.setPagination(res.data.data)
                    history.push(`admin-panel?${queryParams}`)
                })
                .catch(err => {
                    console.log(err.response)
                })
        }
    }
    return(
        <input className={[styles.SearchAutoComplete, "search"].join(' ')} onChange={e => handleSearch(e.target.value)} placeholder="Search by username, role,..." type="text"/>
    )
}
export default SearchAutoComplete;